function Behavior({ content }: { content: string }) {
  return (
    <span className="pre-wrap" style={{ fontSize: "14px" }}>
      {content}
    </span>
  );
}

export default Behavior;
